import { cva } from "class-variance-authority";
/**
 * Single OTP digit cell — colors, border, and focus states come from `.mfa-code-input*` in
 * `theme/tokens.css`; width/height use the Tailwind spacing scale (4px base, see PR styling rules).
 */
export const mfaCodeDigitVariants = cva([
    "mfa-code-input",
    "h-14 shrink-0",
    "w-12",
    "md:w-11",
    "lg:w-14",
], {
    variants: {
        error: {
            true: ["mfa-code-input-error"],
            false: [],
        },
        disabled: {
            true: ["mfa-code-input-disabled"],
            false: [],
        },
        success: {
            true: ["mfa-code-input-success"],
            false: [],
        },
    },
    defaultVariants: {
        error: false,
        disabled: false,
        success: false,
    },
});
//# sourceMappingURL=mfa-code-digit.styles.js.map